import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { motion } from "framer-motion";
import "../css/Login.css";
import aidoralogo from "../assets/beintelli.png";
import googleIcon from "../assets/icons/google.png";
import viewIcon from "../assets/icons/view.png";
import hideIcon from "../assets/icons/hide.png";

export default function Login() {
  const { login, loading, error } = useAuth();
  const navigate = useNavigate();

  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  // 🔐 Normal Login
  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = await login(identifier, password);

    if (data) {
      if (data.admin) {
        // Admin bypasses OTP — save token and go directly
        localStorage.setItem("token", data.token);
        localStorage.setItem("role", data.role);
        if (data.name)  localStorage.setItem("name",  data.name);
        if (data.email) localStorage.setItem("email", data.email);
        window.location.href = "/admin";
        return;
      }
      navigate("/verify-otp", {
        state: {
          user_id: data.user_id,
          role: data.role,
        },
      });
    }
  };

  //  Social Login
  const handleSocialLogin = (provider) => {
    const base = process.env.REACT_APP_API_BASE?.replace("/handlers", "") || "https://beintelli.engaggio.com";
    window.location.href = `${base}/handlers/auth/${provider}`;
  };

  return (
    <div className="login-wrapper">
      <div className="login-main">
        
        {/* LEFT SIDE */}
        <div className="login-left">
          <img
            src={aidoralogo}
            alt="Aidora Logo"
            className="login-aidora-logo"
          />
          <p className="login-aidora-text">
            A PRODUCT BY ENGAGGIO<br />
            POWERED BY BEHAVIOURAL INTELLIGENCE SCIENCE AND ARTIFICIAL INTELLIGENCE.
          </p>
        </div>

        {/* RIGHT SIDE */}
        <motion.div
          className="login-right"
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
        >
          <form className="login-card" onSubmit={handleSubmit}>
            <h2>Sign In</h2>

            {error && <div className="login-error">{error}</div>}

            {/* Identifier */}
            <div className="login-floating-field">
              <input
                placeholder=" "
                type="text"
                required
                value={identifier}
                onChange={(e) => setIdentifier(e.target.value)}
              />
              <label>Username / Email / Phone</label>
            </div>

            {/* Password */}
<div className="login-floating-field">
  <input
    placeholder=" "
    type={showPassword ? "text" : "password"}
    required
    value={password}
    onChange={(e) => setPassword(e.target.value)}
  />
  <label>Password</label>

  <span
    className="toggle-password"
    onClick={() => setShowPassword(!showPassword)}
  >
    <img
      src={showPassword ? viewIcon : hideIcon}
      alt="toggle password"
    />
  </span>
</div>

            {/* Forgot Password */}
            <div className="login-forgot">
              <span onClick={() => navigate("/forgot-password")}>
                Forgot Password?
              </span>
            </div>

            {/* Login Button */}
            <button className="login-button" disabled={loading}>
              {loading ? "Signing in..." : "Login"}
            </button>

            {/* Sign Up */}
            <button
              type="button"
              className="login-signup-button"
              onClick={() => navigate("/signup")}
            >
              Don't have an account? Sign Up
            </button>

            {/* Divider */}
            <div className="login-divider">
  <span>or login with</span>
</div>

<div className="social-login-row">
  <button
    type="button"
    className="social-btn google"
    onClick={() => handleSocialLogin("google")}
  >
    <img src={googleIcon} alt="google" />
    Google
  </button>

</div>
          </form>
        </motion.div>
      </div>
    </div>
  );
}